import { useState, useEffect, useContext } from "react";
import { DashboardTable } from "../components/courseTableComp";
import { GoalDoughnutChart } from "../components/graphComp";
import { HorizontalLayout, VerticalPageLayout } from "../components/layout";
import { RecentActivities } from "../components/recentActivities";
import { StatsRow } from "../molecule/statsrow";
import { getAPI, postAPI } from "../api/api";
import { VideoFallback } from "../molecule/VideoFallback";
import dashboardIntroVideo from "../assets/video/dashboard-intro.mp4";
import dashboardIntroVideoTablet from "../assets/video/dashboard-intro-tablet.mp4";
import dashboardIntroVideoPhone from "../assets/video/dashboard-intro-phone.mp4";
import { PageContext } from "../App";
import { DashboardBoardGraph } from "../components/dashboardGraph";
import { GoalSettingsModal } from "../components/customModals";
import { IconButton } from "../atoms/buttons";
import { icon } from "../functions/icons";

export function Dashboard({ pageSwap, CustomerStage }) {
  const [isLoading, setIsLoading] = useState(true);
  const [simplePeriod, setSimplePeriod] = useState({});
  const [graphPeriod, setGraphPeriod] = useState({});
  const [stats, setStats] = useState([]);
  const [availableMetrics, setAvailableMetrics] = useState([]);
  const [statKeys, setStatKeys] = useState([]);
  const [graphStats, setGraphStats] = useState({});
  const [graphStatKeys, setGraphStatKeys] = useState([]);

  const [tableData, setTableData] = useState({});
  const navigationContext = useContext(PageContext);

  const [goalModalVisible, setGoalModalVisible] = useState(false);
  const [goalSettings, setGoalSettings] = useState(null);
  const [goalCurrentValue, setGoalCurrentValue] = useState(0);
  const [goalLoading, setGoalLoading] = useState(true);
  function getGraphDataset(stats, key) {
  if (!stats || !key || !Array.isArray(stats[key]?.graph_stats)) return [];
  return stats[key].graph_stats.map(item => Number(item.total_value) || 0);
}
  const GoToReport = (id_course) => {
    console.log("selected id: ", id_course)
    navigationContext.handleNavigation({
      navigation: 11,
      courseID: id_course,
      enrollment: 0,
    })
  }
 useEffect(() => {
  loadStatsRow()
  loadGoalSettings()
  loadAvailableMetrics()
}, []);

 const loadStatsRow = async () => {
    const stats = await getAPI(`api/reports/dashboard?customer_stage=${CustomerStage}`);
    console.log(stats)
    setStats(stats.data)
 }

 const loadAvailableMetrics = async () => {
    const res = await getAPI(`api/reports/dashboard/options/available?customer_stage=${CustomerStage}`)
    if (res.data) {
      setAvailableMetrics(res.data)
    }
 }

 const loadGoalSettings = async () => {
    setGoalLoading(true)
    try {
      const res = await getAPI(`api/reports/dashboard/goal?customer_stage=${CustomerStage}`)
      if (res.status === "ok" && res.data) {
        setGoalSettings(res.data)
        loadGoalProgress(res.data.metricId, res.data.period)
      } else {
        setGoalSettings(null)
        setGoalCurrentValue(0)
      }
    } catch (err) {
      setGoalSettings(null)
    }
    setGoalLoading(false)
 }

 const loadGoalProgress = async (metricId, period) => {
    if (!metricId) return
    try {
      const res = await getAPI(`api/reports/dashboard/goal/progress?metric_id=${metricId}&period=${period}`)
      if (res.status === "ok") {
        setGoalCurrentValue(res.data?.current || 0)
      }
    } catch (err) {
      setGoalCurrentValue(0)
    }
 }

 const saveGoalSettings = async (newSettings) => {
    const res = await postAPI(`api/reports/dashboard/goal`, newSettings)
    if (res.status === "ok") {
      setGoalSettings(newSettings)
      loadGoalProgress(newSettings.metricId, newSettings.period)
    }
 }  




 const graphDataset = getGraphDataset(graphStats, graphStatKeys[0]);
  const loadStats = async () => {
    const stat = await getAPI(`api/reports/dashboard?customer_stage=${CustomerStage}`);
    setStats(stat.data);
  };
 const firstKey = graphStatKeys[0];
  const graphTitle = firstKey && graphStats[firstKey]?.pretty_name;

if (!isLoading && statKeys.length === 0 && graphStatKeys.length === 0) {
  return <VideoFallback subTitle={"Er zijn op dit moment nog geen statistieken beschikbaar. Bekijk de introductievideo om je op weg te helpen."} title={"Dashboard"} pageSwap={pageSwap} desktopSrc={dashboardIntroVideo} tabletSrc={dashboardIntroVideoTablet} phoneSrc={dashboardIntroVideoPhone} />
}
  return (
    <VerticalPageLayout className={`dashboard-container page-in-animation ${pageSwap && "page-out-animation"}`}>

      <StatsRow customerStage={CustomerStage} stats={stats} loadStats={loadStats} />
      
      <HorizontalLayout className="dashboard-graph" style={{ alignItems: "unset" }}>
      <div className="vertical side-content-left complete-width dashboard-graph-content" style={{"height": "max-content"}}>
          <div
            className="vertical graph standard-rounded standard-padding card-background-color standard-border "
            style={{ width: "unset" }}
          >
          <DashboardBoardGraph customerStage={CustomerStage}/>
            
            
          </div>
          <DashboardTable GoToReport={GoToReport} data={tableData}/>
          </div>
        <div className="vertical right-content side-content-right dashboard-graph-content">
          <div
            className="vertical graph standard-rounded standard-padding card-background-color standard-border "
            style={{ width: "unset" }}
          >
            <GoalGraphSection
              goalSettings={goalSettings}
              goalCurrentValue={goalCurrentValue}
              goalLoading={goalLoading}
              onSettingsClick={() => setGoalModalVisible(true)}
            />
          </div>
          <RecentActivities

          />
        </div>
      </HorizontalLayout>

      <GoalSettingsModal
        customerStage={CustomerStage}
        visible={goalModalVisible}
        dismiss={() => setGoalModalVisible(false)}
        goalSettings={goalSettings}
        onSave={saveGoalSettings}
        availableMetrics={availableMetrics}
      />
    </VerticalPageLayout>
  );
}

function GoalGraphSection({ goalSettings, goalCurrentValue, goalLoading, onSettingsClick }) {
  const hasGoal = goalSettings && goalSettings.goalValue > 0

  return (
    <div className="goal-graph-section" style={{height: "100%"}}>
      <HorizontalLayout className="goal-graph-header">
        <p className="diagram-title">{hasGoal ? goalSettings.metricName : "Doelen"}</p>
        <IconButton
          icon2="settings"
          onClick={onSettingsClick}
          className="goal-settings-btn"
          size={18}
        />
      </HorizontalLayout>

      {hasGoal ? (
        <div style={{height: "100%", width: "100%"}} className="flex center-all"><GoalDoughnutChart
          loading={goalLoading}
          currentValue={goalCurrentValue}
          goalValue={goalSettings.goalValue}
          metricName={goalSettings.metricName}
        />
        </div>
      ) : (
        <div className="complete-height complete-width center-all flex" style={{height: "calc(100% - 3rem)", textAlign: "center"}}>
          <div style={{color: "#999"}}>
            <span style={{color: "#666"}}>{icon("goal", 64)}</span><br/>
            <p>Nog geen doel ingesteld, druk op het tandwiel om te beginnen.</p>
          </div>
        </div>
      )}
    </div>
  )
}
